const GOOGLE_MAPS_CALLBACK_NAME = 'onGbMapsInit';

export { GOOGLE_MAPS_CALLBACK_NAME };
